<template>
<v-card class="my-3">
  <v-card-title class="title">
    Summary
    <v-spacer />
    <v-dialog v-model="editing" max-width="600px" v-if="edit">
      <v-btn color="secondary darken-2" slot="activator">
        <v-icon left>mdi-pencil</v-icon> Edit
      </v-btn>
      <v-card>
        <v-card-title class="headline">
          Edit Summary
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid" @submit.prevent="submit">
            <v-textarea label="Summary"
              v-model="summary"
              required :rules="rules.summary"
              :error-messages="errors.summary || []"
              rows="10"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="cancel">
            Cancel
          </v-btn>
          <v-btn :color="valid ? 'success' : 'error'" :disabled="!valid" @click="submit">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card-title>
  <v-card-text v-if="organization">
    <markdown class="markdown" :html="false" :source="organization.summary" v-if="organization.summary"/>
    <v-alert v-else type="info" color="secondary darken-2" :value="true">
      Please provide an organization summary.
    </v-alert>
  </v-card-text>
</v-card>
</template>

<script>
import Markdown from 'vue-markdown'

export default {
  components: {
    Markdown
  },
  props: { organization: Object, edit: Boolean },
  data() {
    return {
      editing: false,
      valid: false,
      rules: {
        summary: [v => !!v || 'must be specified']
      },
      errors: {},
      modified: Object.assign({}, this.organization),
      summary: this.organization.summary
    }
  },
  methods: {
    cancel() {
      this.summary = this.organization.summary
      this.editing = false
      this.errors = {}
    },
    submit() {
      if (this.valid) {
        this.modified.summary = this.summary
        this.update()
      }
    },
    update() {
      this.$store
        .dispatch('client/organization/update', this.modified)
        .then(errors => {
          if (errors) {
            this.errors = errors
            this.$store.dispatch(
              'snackbarError',
              'There was a problem saving the summary'
            )
          } else {
            this.$store.dispatch(
              'snackbarSuccess',
              'The summary was saved successfully'
            )
            this.editing = false
          }
        })
    }
  }
}
</script>
